// tslint:disable
/**
 * Exyzt Authentication
 * Exyzt Authentication
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from "url";
import { Configuration } from "./configuration";
import globalAxios, { AxiosPromise, AxiosInstance } from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError
} from "./base";

/**
 *
 * @export
 * @interface ApiResponse
 */
export interface ApiResponse {
  /**
   *
   * @type {number}
   * @memberof ApiResponse
   */
  code?: number;
  /**
   *
   * @type {string}
   * @memberof ApiResponse
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof ApiResponse
   */
  message?: string;
}
/**
 *
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
  /**
   *
   * @type {string}
   * @memberof LoginResponse
   */
  token?: string;
  /**
   *
   * @type {boolean}
   * @memberof LoginResponse
   */
  mustChangePassword?: boolean;
}
/**
 *
 * @export
 * @interface PasswordChangeError
 */
export interface PasswordChangeError {
  /**
   *
   * @type {string}
   * @memberof PasswordChangeError
   */
  code?: PasswordChangeErrorCodeEnum;
  /**
   *
   * @type {string}
   * @memberof PasswordChangeError
   */
  message?: string;
  /**
   *
   * @type {Array<object>}
   * @memberof PasswordChangeError
   */
  data?: Array<object>;
}

/**
 * @export
 * @enum {string}
 */
export enum PasswordChangeErrorCodeEnum {
  MISSA = "MISSA",
  MISSPASS = "MISSPASS",
  INVPASS = "INVPASS"
}

/**
 *
 * @export
 * @interface StadeCardChangePasswordForm
 */
export interface StadeCardChangePasswordForm {
  /**
   *
   * @type {StadeCardChangePasswordFormPlainPassword}
   * @memberof StadeCardChangePasswordForm
   */
  plainPassword?: StadeCardChangePasswordFormPlainPassword;
  /**
   *
   * @type {string}
   * @memberof StadeCardChangePasswordForm
   */
  oldPassword?: string;
  /**
   *
   * @type {string}
   * @memberof StadeCardChangePasswordForm
   */
  cardSerialNumber?: string;
}
/**
 *
 * @export
 * @interface StadeCardChangePasswordFormPlainPassword
 */
export interface StadeCardChangePasswordFormPlainPassword {
  /**
   *
   * @type {string}
   * @memberof StadeCardChangePasswordFormPlainPassword
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof StadeCardChangePasswordFormPlainPassword
   */
  srcond?: string;
}
/**
 *
 * @export
 * @interface StadeCardLoginForm
 */
export interface StadeCardLoginForm {
  /**
   *
   * @type {string}
   * @memberof StadeCardLoginForm
   */
  _username: string;
  /**
   *
   * @type {string}
   * @memberof StadeCardLoginForm
   */
  _password: string;
  /**
   *
   * @type {string}
   * @memberof StadeCardLoginForm
   */
  _sn: string;
  /**
   *
   * @type {string}
   * @memberof StadeCardLoginForm
   */
  _cardId: string;
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function(
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Login using StaDe NFC card protocol
     * @param {StadeCardChangePasswordForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stadeCardChangePassword: async (
      body: StadeCardChangePasswordForm,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling stadeCardChangePassword."
        );
      }
      const localVarPath = "/stade-card/change-password";
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Login using StaDe NFC card protocol
     * @param {string} username
     * @param {string} password
     * @param {string} sn
     * @param {string} cardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stadeCardLogin: async (
      username: string,
      password: string,
      sn: string,
      cardId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'username' is not null or undefined
      if (username === null || username === undefined) {
        throw new RequiredError(
          "username",
          "Required parameter username was null or undefined when calling stadeCardLogin."
        );
      }
      // verify required parameter 'password' is not null or undefined
      if (password === null || password === undefined) {
        throw new RequiredError(
          "password",
          "Required parameter password was null or undefined when calling stadeCardLogin."
        );
      }
      // verify required parameter 'sn' is not null or undefined
      if (sn === null || sn === undefined) {
        throw new RequiredError(
          "sn",
          "Required parameter sn was null or undefined when calling stadeCardLogin."
        );
      }
      // verify required parameter 'cardId' is not null or undefined
      if (cardId === null || cardId === undefined) {
        throw new RequiredError(
          "cardId",
          "Required parameter cardId was null or undefined when calling stadeCardLogin."
        );
      }
      const localVarPath = "/login/stade-card";
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new URLSearchParams();

      if (username !== undefined) {
        localVarFormParams.set("_username", username as any);
      }

      if (password !== undefined) {
        localVarFormParams.set("_password", password as any);
      }

      if (sn !== undefined) {
        localVarFormParams.set("_sn", sn as any);
      }

      if (cardId !== undefined) {
        localVarFormParams.set("_cardId", cardId as any);
      }

      localVarHeaderParameter["Content-Type"] =
        "application/x-www-form-urlencoded";

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = localVarFormParams.toString();

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
  return {
    /**
     *
     * @summary Login using StaDe NFC card protocol
     * @param {StadeCardChangePasswordForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async stadeCardChangePassword(
      body: StadeCardChangePasswordForm,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await AuthenticationApiAxiosParamCreator(
        configuration
      ).stadeCardChangePassword(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Login using StaDe NFC card protocol
     * @param {string} username
     * @param {string} password
     * @param {string} sn
     * @param {string} cardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async stadeCardLogin(
      username: string,
      password: string,
      sn: string,
      cardId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>
    > {
      const localVarAxiosArgs = await AuthenticationApiAxiosParamCreator(
        configuration
      ).stadeCardLogin(username, password, sn, cardId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    }
  };
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function(
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Login using StaDe NFC card protocol
     * @param {StadeCardChangePasswordForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stadeCardChangePassword(
      body: StadeCardChangePasswordForm,
      options?: any
    ): AxiosPromise<void> {
      return AuthenticationApiFp(configuration)
        .stadeCardChangePassword(body, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Login using StaDe NFC card protocol
     * @param {string} username
     * @param {string} password
     * @param {string} sn
     * @param {string} cardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stadeCardLogin(
      username: string,
      password: string,
      sn: string,
      cardId: string,
      options?: any
    ): AxiosPromise<LoginResponse> {
      return AuthenticationApiFp(configuration)
        .stadeCardLogin(username, password, sn, cardId, options)
        .then(request => request(axios, basePath));
    }
  };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
  /**
   *
   * @summary Login using StaDe NFC card protocol
   * @param {StadeCardChangePasswordForm} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public stadeCardChangePassword(
    body: StadeCardChangePasswordForm,
    options?: any
  ) {
    return AuthenticationApiFp(this.configuration)
      .stadeCardChangePassword(body, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Login using StaDe NFC card protocol
   * @param {string} username
   * @param {string} password
   * @param {string} sn
   * @param {string} cardId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public stadeCardLogin(
    username: string,
    password: string,
    sn: string,
    cardId: string,
    options?: any
  ) {
    return AuthenticationApiFp(this.configuration)
      .stadeCardLogin(username, password, sn, cardId, options)
      .then(request => request(this.axios, this.basePath));
  }
}
